<template>
  <SubContent h="550px" @back="toCancel">
    <template v-slot:nav_left> 添加训练督导 </template>
    <div class="page-content">
      <div class="form_wrap">
        <vue-scroll>
          <div class="scroll-content form-content">
            <el-form
              :inline="false"
              ref="form"
              :model="form"
              :rules="formRules"
              label-width="105px"
            >
              <fieldset class="vita-form-fieldset">
                <legend style="margin-left:20px">单位信息</legend>
                <el-row>
                  <el-col :span="12">
                    <el-form-item  label="管理协会" label-width="125px" prop="organShortName" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="form.organShortName" class="w280" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="单位" label-width="125px" prop="youthShortName" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="form.youthShortName" class="w280" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="球队" label-width="125px" prop="shortName" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="form.shortName" class="w280" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="性别" label-width="125px" prop="gender" :rules="[{ required: true, message: '必填项',trigger: 'change' }]">
                      <el-select v-model="form.gender" class="w280" placeholder="选择性别">
                        <el-option v-for="(item,index) in squadSexList" :key="index" :label="item.value" :value="item.key"/>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="训练开始时间" label-width="125px" prop="supervisoryTime" :rules="[{ required: true, message: '必填项',trigger: 'change' }]">
                      <el-date-picker v-model="form.supervisoryTime" class="w280" align="right" type="datetime" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="训练结束时间" label-width="125px" prop="supervisoryEndTime" :rules="[{ required: true, message: '必填项',trigger: 'change' }]">
                      <el-date-picker v-model="form.supervisoryEndTime" class="w280" align="right" type="datetime" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="教练员" label-width="125px" prop="coachUuid" :rules="[{ required: false, message: '必填项',trigger: 'change' }]">
                      <el-select v-model="form.coachUuid" filterable multiple class="w280" placeholder="选择教练员">
                        <el-option v-for="(item,index) in coachesList" :key="index" :label="item.idName" :value="item.uuid"/>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="训练主题" label-width="125px" prop="trainTitle" :rules="[{ required: true, message: '必填项'}]">
                      <el-input v-model="form.trainTitle"  class="w280" maxlength="80" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>

                </el-row>

                <el-row>
                  <el-col :span="24">
                    <el-form-item label="备注" label-width="125px">
                      <el-input v-model.trim="form.otherCoach" style="width:672px" placeholder="例如教练员名单不在系统内无法选择，可以在此处手动填写教练员姓名" maxlength="80" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>

                </el-row>
              </fieldset>
              <fieldset class="vita-form-fieldset">
                <legend style="margin-left:20px">队伍</legend>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="人员" prop="squadPerson" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="form.squadPerson" class="w380" type="textarea" :rows="3" placeholder="观察内容：人数，队伍情况" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="场地" prop="squadVenue" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="form.squadVenue" class="w380" type="textarea" :rows="3" placeholder="观察内容：使用时间，区域" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="队伍架构" prop="squadDisposition" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="form.squadDisposition" class="w380" type="textarea" :rows="3" placeholder="观察内容：教练配置情况" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="基本信息" prop="squadBaseInfo" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="form.squadBaseInfo" class="w380" type="textarea" :rows="3" placeholder="观察内容：等级，培训，成绩" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>

              <fieldset class="vita-form-fieldset">
                <legend style="margin-left:20px">教练</legend>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="个人形象" prop="coachPersonalImage" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="form.coachPersonalImage" class="w380" type="textarea" :rows="3" placeholder="观察内容：精神面貌，服饰，仪表、态度" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="教案设计" prop="coachPlanDevise" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="form.coachPlanDevise" class="w380" type="textarea" :rows="3" placeholder="观察内容：主题、针对性、
真实性、合理性" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="组织安排" prop="coachArrangement" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="form.coachArrangement" class="w380" type="textarea" :rows="3" placeholder="观察内容：时间安排，场地布置，器材使用" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="观察指导" prop="coachObservational" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="form.coachObservational" class="w380" type="textarea" :rows="3" placeholder="观察内容：发现、洞察，重组，改进、效果" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="沟通交流" prop="coachCommunication" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="form.coachCommunication" class="w380" type="textarea" :rows="3" placeholder="观察内容：提问、引导、讲解，肢体语言及示范" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>

              <fieldset class="vita-form-fieldset">
                <!--<legend style="margin-left:20px">机构现状</legend>-->
                <el-row>
                  <el-col :span="34">
                    <el-form-item label="机构现状" prop="youthBaseStatus" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="form.youthBaseStatus" class="w480" type="textarea" :rows="2" placeholder="" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="34">
                    <el-form-item label="工作亮点" prop="workHighlights" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="form.workHighlights" class="w480" type="textarea" :rows="2" placeholder="" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="34">
                    <el-form-item label="问题及建议" prop="questionsSuggestions" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="form.questionsSuggestions" class="w480" type="textarea" :rows="2" placeholder="" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="34">
                    <el-form-item label="综合评价" prop="comprehensive" :rules="[{ required: true, message: '必填项',trigger: 'change' }]">
                      <el-radio-group v-model="form.comprehensive">
                        <el-radio :label="'好'" border>好</el-radio>
                        <el-radio :label="'较好'" border>较好</el-radio>
                        <el-radio :label="'一般'" border>一般</el-radio>
                        <el-radio :label="'不理想'" border>不理想</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>

              <el-row>
                <el-col :span="24">
                  <el-form-item label="签字人（可多选）" label-width="165px" prop="supervisorySignatoriesUuids" :rules="[{ required: false, message: '必填项',trigger: 'change' }]">
                    <el-select v-model="form.supervisorySignatoriesUuids" filterable multiple style="width:430px" placeholder="选择签字人">
                      <el-option v-for="(item,index) in supervisoryList" :key="index" :label="item.supervisoryName" :value="item.supervisoryUuid"/>
                    </el-select>
                  </el-form-item>
                </el-col>
                <span style="color:#f88594">注：添加签字人信息后将生成本报告的最终版本，提交后将无法修改。</span>
              </el-row>

            </el-form>
          </div>
        </vue-scroll>
        <yioks-tips
          :showTip="tipsFlag"
          :tipMsg="form.supervisorySignatoriesUuids.length ? '添加签字人信息后将生成本报告的最终版本，提交后将无法修改，请确认是否提交？' : '请确认保存并退出？'"
          :loading="repeatSubmit"
          @callback="hideTipsDialog"
        ></yioks-tips>
        <yioks-tips
          :showTip="tipsFlagCancel"
          tipMsg="请确认放弃保存并返回吗？"
          :loading="repeatSubmitCancel"
          @callback="hideTipsDialogCancel"
        ></yioks-tips>
      </div>
    </div>

    <template v-slot:btn>
      <div class="btn_wrap">
        <el-button type="primary" @click="tempSave">保存</el-button>
        <el-button type="danger" @click="toCancel">取消</el-button>
      </div>
    </template>
  </SubContent>
</template>

<script>
  import scout from "@/api/scout";
  import supervision from "@/api/supervision";
  import player from "@/api/player"; // getPlayerInfo获取球员信息
  import squad from "@/api/squad"; // getPlayerInfo获取球员信息
  import storage from "@/utils/storage";
  import {filterIdNumber} from "@/utils/yioks_filter";
  import { squadSexList } from '@/utils/yioks_data'

  export default {
  name: "ScoutList",

  data() {
    return {
      squadSexList,
      tipsFlag: false,
      repeatSubmit: false,
      tipsFlagCancel: false,
      repeatSubmitCancel: false,
      repeatNext: false,
      tipsFlagNext: false,
      userRole: storage.get("userInfo").userRole,
      uuid: storage.get("userInfo").uuid,
      activeStep: 1,
      coachesList:[],
      supervisoryList:[],
      form: {
        organUuid:'',
        youthUuid:'',
        squadUuid:'',
        organShortName:'',
        youthShortName:'',
        shortName:'',
        writeTime:new Date().getTime(),// 填写时间
        supervisoryTime:'',// 督训时间
        supervisoryEndTime:'',// 督训时间
        trainTitle:'',// 主题
        otherCoach:'',// 其他
        gender:'',// 性别
        coachUuid:[],// 教练员Uuid
        squadPerson:'',// 队伍人员
        squadVenue:'',// 队伍场地
        squadDisposition:'',// 队伍架构
        squadBaseInfo:'',// 队伍基本信息
        coachPersonalImage:'',// 教练个人形象
        coachPlanDevise:'',// 教练教案设计
        coachArrangement:'',// 教练组织安排
        coachObservational:'',// 教练观察指导
        coachCommunication:'',// 教练沟通交流
        youthBaseStatus:'',// 机构现状
        workHighlights:'',// 工作亮点
        questionsSuggestions:'',// 问题及建议
        comprehensive:'',// 综合评价：好、较好、一般、不理想
        comprehensiveIntro:'',// 综合评价--描述
        supervisorySignatories:'',// 签字人
        supervisorySignatoriesUuids:[],// 签字人
      },
      formRules: {
      },
    };
  },

  components: {
    SubContent: () => import("@/components/layout/contentWithbtn"),
    "yioks-tips": () => import("@/components/YioksTip"),
  },

  computed: {
    organUuid() {
      return this.$route.query.organUuid || "";
    },
    youthUuid() {
      return this.$route.query.youthUuid || "";
    },
    squadUuid() {
      return this.$route.query.squadUuid || "";
    },
  },

  created() {
    // 请求一下球队的相关信息
    this.loadSquadInfo();
    this.getSupervisoryPersonList();
  },

  mounted() {
  },

  methods: {
    /* 暂时保存 */
    tempSave(status) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.tipsFlag = true;
        }else {
          this.$message.error("请完善所有带 * 的必填项");
        }
      });
    },
    /* 暂时保存 */
    hideTipsDialog(ok) {
      if (ok) {
        if(this.form.coachUuid.length===0 && !this.form.otherCoach){
          this.$message.error("教练员未添加");
          return
        }
        if (!this.repeatSubmit) {
          this.repeatSubmit = true;
          this.$refs["form"].validate((valid) => {
            if (valid) {
              let coachNames = [];
              this.form.coachUuid.map(ite=>{
                let coachName = this.coachesList.find((item) => {
                  return item.uuid === ite;
                }).idName
                coachNames.push(coachName);
              });

              let supervisoryNames = [];
              this.form.supervisorySignatoriesUuids.map(ite=>{
                let supervisoryName = this.supervisoryList.find((item) => {
                  return item.supervisoryUuid === ite;
                }).supervisoryName
                supervisoryNames.push(supervisoryName);
              });

              const {coachUuid,supervisorySignatoriesUuids,...rest } = this.form;
              let aimData = {
                ...rest,
                coachUuid : coachUuid.join(","),
                trainCoach : coachNames.join(","),
                supervisorySignatoriesUuids : supervisorySignatoriesUuids ? supervisorySignatoriesUuids.join(",") : '',
                supervisorySignatories : supervisoryNames ? supervisoryNames.join(",") : '',
              };
              supervision.addSupervisory(aimData).then((res) => {
                this.repeatSubmit = false;
                this.tipsFlag = false;
                if (res.code) {
                  this.$message.error(res.msg);
                } else {
                  this.$router.go(-1);
                }
              })
              .catch((err) => {
                this.repeatSubmit = false;
                this.tipsFlag = false;
                console.log(err);
              });
            }
          });
        }
      } else {
        this.repeatSubmit = false;
        this.tipsFlag = false;
      }
    },
    /* 取消 */
    toCancel() {
      this.tipsFlagCancel = true;
    },
    hideTipsDialogCancel(ok) {
      if (ok) {
        this.repeatSubmitCancel = false;
        this.tipsFlagCancel = false;
        this.$router.go(-1);
      } else {
        this.repeatSubmitCancel = false;
        this.tipsFlagCancel = false;
      }
    },

    /* 获取球队信息 */
    loadSquadInfo() {
      squad.getSquadInfo(this.squadUuid).then((res) => {
          this.$set(this.form, "squadUuid", this.squadUuid);
          this.$set(this.form, "youthUuid", res.squad.youthUuid);
          this.$set(this.form, "youthShortName",  res.squad.youthShortName);
          this.$set(this.form, "organUuid",  res.squad.organUuid);
          this.$set(this.form, "organShortName", res.squad.organShortName);
          this.$set(this.form, "shortName", res.squad.shortName);
          this.$set(this.form, "gender", res.squad.squadSex);

          this.coachesList = res.coaches
        })
        .catch((err) => {
          console.error("请求异常", err);
        });
    },
    getSupervisoryPersonList() {
      supervision.supervisoryPersonList().then((res) => {
        if (res.code) {
          this.$message.error(res.msg);
          return
        }
        this.supervisoryList = res
      })
      .catch((err) => {
        console.error("请求异常", err);
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.form_wrap
  padding 20px
  overflow hidden
  box-sizing border-box
  flex 1
  font-size 16px
  height 554px
  .vita-form-fieldset
    margin: 0 0 20px 0;
    padding: 10px 10px 0;
    border: 1px dashed $color_white;
    width: 97%
.step-box
  margin-top 10px
.btn_wrap
  width 100%
  display flex
  justify-content center
.w380
  width 300px
.w280
  width 270px
.w480
  width 480px
.w150
  width 160px
.player-list-wrapper
  width 95%
  display flex
  justify-content space-around
  border-bottom 1px dashed #ccc
  border-top 1px dashed #ccc
  padding 20px 20px 0px 0px
  margin-bottom 20px
  .left-box
    width 100%
  .right-box
    width 40px
    display flex
    justify-content center
    flex-direction column
    align-items center
</style>

<style lang="stylus">
.page-content
  .el-steps--simple
    background-color rgba(0, 0, 0, 0)
  .el-form-item__label
    color #fff
    font-size 16px
</style>
<style lang="stylus">
@import '~@/assets/css/variable'
.yioks-switch
  .el-switch__label
    color $color_white
  .el-switch__label--left
    &.is-active
      color $color_white
  .el-switch__label--right
    &.is-active
      color $green_color
.yioks-switch-grey
  .el-switch__label
    color $grey_color
  .el-switch__label--left
    &.is-active
      color $grey_color
  .el-switch__label--right
    &.is-active
      color $green_color
.el-radio
  color: white
input[aria-hidden=true] {
  display: none !important;
}
</style>
